export enum ApiErrorCodeEnum {
	INVESTOR_PERCENTAGE_LIMIT_EXCEEDED = 1036,
	TRANSACTION_DELETE_ONLY_CURRENT_MONTH = 1037,
	TRANSACTION_DELETE_INVESTOR_ID_REQUIRED = 1038,
	TRANSACTION_DELETE_ONLY_OWNER_CAN_DELETE = 1039,
	USER_NOT_CERTIFIED = 1048,
	LIVE_EVENT_INVALID_DATES = 1059,
	LIVE_EVENT_OVERLAP = 1060,
	LIVE_EVENT_NOT_SCHEDULED = 1061,
	PROMO_CODE_TAKEN = 1077,
	PROMO_CODE_LOCKED = 1078,
	PROMO_TARGET_UNKNOWN = 1079,
	PROMO_TARGET_BUSY = 1080
}
